
const activityProcessingDays = [
    {
        "uuid": "1",
        "phase": "documentCheck",
        "activity": "documentCheck_S10",
        "processingDays": 28,
        "createdOn": "2021-10-01T09:15:00.000Z"
    },
    {
        "uuid": "2",
        "phase": "sampling",
        "activity": "inspectionArrangement_S20",
        "processingDays": 4,
        "createdOn": "2021-10-20T20:20:20.000Z"
    },
    {
        "uuid": "3",
        "phase": "documentReview",
        "activity": "documentCheck_S60",
        "processingDays": 8,
        "createdOn": "2021-10-21T12:15:40.000Z"
    },
    {
        "uuid": "4",
        "phase": "inspection",
        "activity": "inspection_S40",
        "processingDays": 16,
        "createdOn": "2021-10-28T16:30:30.000Z"
    }
]

export default activityProcessingDays;